import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { articles } from "../data/articles";
import { Reveal } from "../components/Reveal";
import { ArrowLeft, ArrowRight, Clock } from "lucide-react";

const Blog = () => {
  const { t, lang } = useLanguage();
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  return (
    <main data-testid="blog-page" className="mx-auto max-w-7xl px-6 pb-24 pt-36 lg:px-10 lg:pt-44">
      <Reveal>
        <p className="overline-tag">{t.blog.overline}</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold md:text-6xl">{t.blog.title}</h1>
        <p className="mt-4 max-w-xl text-sm text-zinc-400 md:text-base">{t.blog.sub}</p>
      </Reveal>

      <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}>
            <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
              className="group flex h-full flex-col rounded-3xl border border-white/10 bg-surface p-8 transition-[border-color,transform] duration-500 hover:-translate-y-2 hover:border-gold/40">
              <div className="flex items-center gap-3 text-xs text-zinc-600">
                <span>{a.date}</span>
                <span className="h-1 w-1 rounded-full bg-gold/50" />
                <span className="flex items-center gap-1"><Clock size={12} /> {a.readTime} {t.blog.minRead}</span>
              </div>
              <h2 className="mt-4 font-display text-xl font-bold leading-snug transition-colors duration-300 group-hover:text-gold-light">
                {a.title[lang]}
              </h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-500">{a.excerpt[lang]}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-gold">
                {t.blog.readMore} <Arrow size={14} className="transition-transform duration-300 group-hover:translate-x-1 rtl:group-hover:-translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </main>
  );
};

export default Blog;
